// extracted by mini-css-extract-plugin
module.exports = {"Accordion_heading":"Accordion_Accordion_heading__SsJrk"};